import React, { useEffect, useState } from "react";
import { loadWaConfig, onWaConfig } from "../lib/waTracker";

// Subtle temporary-routing notice — only renders while temp routing is active.
export const TempWaNotice = ({ className = "" }) => {
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    loadWaConfig();
    return onWaConfig(setCfg);
  }, []);

  if (!cfg?.active || !cfg?.notice) return null;
  return (
    <p
      data-testid="temp-wa-notice"
      className={`text-[12px] leading-relaxed text-[#7A6B5F] bg-[#FAF5EC] border border-[#D4A963]/40 px-4 py-3 ${className}`}
    >
      {cfg.notice}
    </p>
  );
};
